const singleAuth = {
  token: '',
}

export { singleAuth }
